import { useState, useEffect, useContext } from 'react';
import '../styles/LandingView.css'
import 'firebase/firestore'
import Place from '../interfaces/Place';
import { Interface } from '../interfaces/Interface';
import Location from '../interfaces/Location';
import SearchContainer from '../components/SearchContainer';
import MapContainer from '../components/MapContainer';
import CardList from '../components/CardList';
import LoginContainer from '../components/LoginContainer';
import LogoutContainer from '../components/LogoutContainer';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import AppContext from '../context/AppContext';
import LandingViewContext from '../context/LandingViewContext';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import LandingViewContent from '../interfaces/LandingViewContent';

const LandingView: React.FC = () => {
  const [marker, setMarker] = useState<Place>(Interface.emptyInterface<Place>());
  const [selectedLocation, setSelectedLocation] = useState<Location>(Interface.emptyInterface<Location>());
  const [open, setOpen] = useState(false);
  const {isAuthenticated, setIsAuthenticated, user, setUser} = useContext(AppContext)
  const [refreshLocations, setRefreshLocations] = useState<boolean>(false); 

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    });
    return () => unsubscribe();
  }, []);

  const context: LandingViewContent = {
    refreshLocations,
    setRefreshLocations
  }

  return (
    <LandingViewContext.Provider value={context}>
      <div className="container">
      {
        isAuthenticated ? (
          <LogoutContainer onLogout={function (): void {
              throw new Error('Function not implemented.');
            } 
          } />          
        ) : (
          <LoginContainer onLogin={function (): void {
              throw new Error('Function not implemented.');
            } 
          } />
        )
      }
        <div className="banner">
          <h1 className='page-title shadowed'>Yo viví en...</h1>
          <h3 className='shadowed'>
            Alquilar está difícil. ¿Sos o fuiste inquilino? Dejá una reseña de los lugares en los que viviste y buscá tu proximo departamento antes de mudarte.
          </h3>
        </div>
        <SearchContainer setMarker={setMarker} isAuthenticated={isAuthenticated} setShowToast={setOpen}/>
      </div>
      <div className="map-view-right">
        <MapContainer marker={marker} setSelectedLocation={setSelectedLocation} />
      </div>
      {
        Interface.isEmpty(selectedLocation) ||
        <CardList location={selectedLocation}/>
      }
      <Snackbar open={open} autoHideDuration={3000} onClose={() => setOpen(false)}>
        <Alert
          onClose={() => setOpen(false)}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Reseña agregada
        </Alert>
      </Snackbar>
    </LandingViewContext.Provider>
  );
}

export default LandingView;
